import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface PatientDetails {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  AllPatientDetails?: any;
}
let initialState: PatientDetails = {
  isLoading: false,
  error: false,
  message: null,
  AllPatientDetails: {},
};
const PatientDetailsSlice = createSlice({
  name: "PatientDetails",
  initialState,
  reducers: {
    loadingPatientDetails: (state: PatientDetails, action: PayloadAction) => {
      state.isLoading = true;
    },
    setPatientDetails: (state: any, action: PayloadAction<PatientDetails>) => {
      return action.payload;
    },
    clearPatientData: (state: PatientDetails, action: PayloadAction) => {
      state.error = false;
      state.AllPatientDetails = {};
      state.isLoading = false;
      state.message = null;
    },
  },
});

export const { loadingPatientDetails, setPatientDetails, clearPatientData } =
  PatientDetailsSlice.actions;

export default PatientDetailsSlice.reducer;
